<template>
    <div>
        <v-card elevation="0">
            <div class="d-flex justify-space-between align-center">
                <v-card-title class="d-flex grow" v-if="$vuetify.breakpoint.mdAndUp">
                    <h3 class="ma-0 font-weight-light">
                        Seguimiento Objetivos
                    </h3>
                </v-card-title>
                <div 
                    v-if="$route.name != 'liquidacion'"
                    :class="
                        $vuetify.breakpoint.smAndDown
                            ? 'justify-center d-flex flex-wrap'
                            : 'd-flex flex-grow-1 justify-lg-end justify-md-end justify-sm-center justify-xs-center flex-wrap'
                    ">
                    <div class="my-1">
                        <v-btn width="210px" v-if="hasManagerPermission" :class="
                                $vuetify.breakpoint.smAndDown
                                    ? 'py-4 mx-2'
                                    : 'py-4 mr-3'
                            " dark small outlined color="orange" @click="openDialogObjetivo">Añadir Objetivo
                            <v-icon right>mdi-bullseye-arrow</v-icon>
                        </v-btn>
                        <FormObjetivo />
                    </div>
                    <div class="my-1">
                        <CopyObjetivo />
                    </div>
                </div>
            </div>
            <!-- <v-divider class="test mb-2"></v-divider> -->
            <v-data-table :headers="headers" :items="
                    singleView ? singleObjectives : objetivoComercial.length ? objetivoComercial : objetivo
                " :item-class="
                    switchColorTable
                        ? itemRowBackgroundFivePercent
                        : itemRowBackground
                " :loading="isLoadingFormObjetivo || isLoadingObjetivos" align-center style="height: 100%"
                hide-default-footer :footer-props="footersProps">
                <template v-slot:item.peso="{ item }">
                    {{ isInt(item.peso) ? parseInt(item.peso) : item.peso }}%
                </template>
                <template v-slot:item.familia="{ item }">
                    {{ item.familia.nombre }}
                </template>
                <template v-slot:item.objetivo_porc="{ item }">
                    {{ item.objetivo_porc }}
                    {{ item.objetivo == '' ? '-' : '%' }}
                </template>
                <template v-slot:item.comision_porc="{ item }">
                    {{ item.comision_porc ? `${item.comision_porc} %` : '-' }}
                </template>
                <template v-slot:item.five_percent="{ item }">
                    {{
                    item.five_percent == -1
                    ? '-'
                    : `${Math.round(item.five_percent)}`
                    }}
                </template>
                <template v-if="hasManagerPermission" v-slot:item.Actions="{ item }">
                    <div class="d-flex">
                        <v-icon size="28" style="
                                background-color: white;
                                border-radius: 10px;
                                padding: 3px;
                            " class="mx-4" :disabled="isLoadingFormObjetivo || !item.id"
                            @click="editObjetivoForm(item)" color="orange darken-1">
                            mdi-pen
                        </v-icon>
                        <v-icon size="28" style="
                                background-color: white;
                                border-radius: 10px;
                                padding: 3px;
                            " class="mx-4" :disabled="isLoadingFormObjetivo || !item.id" @click="deleteObjetivo(item)"
                            color="red">
                            mdi-delete-empty
                        </v-icon>
                    </div>
                </template>
                <template v-slot:footer>
                    <v-divider></v-divider>
                    <!-- Create switch -->
                    <div class="d-flex justify-space-between">
                        <div class="d-flex justify-start">
                            <v-switch v-if="hasManagerPermission" v-model="switchColorTable"
                                class="ma-0 ml-2 align-self-center" color="primary"
                                :label="!switchColorTable ? '± 5 %' : 'Clásico'" dense hide-details></v-switch>
                            <v-switch v-if="hasTeamObjectives && hasManagerPermission" v-model="singleView"
                                class="ma-0 ml-2 align-self-center" color="primary" dense
                                :label="singleView ? 'Individual' : 'Equipo'" hide-details></v-switch>
                        </div>
                        <div class="d-flex justify-end align-self-end">
                            <small class="mx-4 my-2">Total de objetivos:
                                <span class="ms-2">
                                    {{
                                    singleView
                                    ? singleObjectives.length
                                    : objetivoComercial.length
                                    }}
                                </span></small>
                        </div>
                    </div>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import { formatDate } from '@/util/libUtil.js';
import FormObjetivo from './FormObjetivo.vue';
import CopyObjetivo from './CopyObjetivo.vue';

export default {
    name: 'TablaTotales',
    components: {
        FormObjetivo,
        CopyObjetivo,
    },
    data: () => ({
        singleView: false,
        switchColorTable: true,
        footersProps: {
            disableItemsPerPage: false,
            itemsPerPageOptions: [-1],
        },
        headers: [
            {
                text: 'Peso',
                align: 'center',
                value: 'peso',
            },
            {
                text: 'Familia',
                align: 'center',
                value: 'familia',
            },
            {
                text: 'Objetivo',
                align: 'center',
                value: 'objetivo',
            },
            {
                text: 'Realizado',
                align: 'center',
                value: 'consecucion',
            },
            {
                text: '% Objetivo',
                align: 'center',
                value: 'objetivo_porc',
            },
            {
                text: 'Proyección deseada',
                align: 'center',
                value: 'five_percent',
            },
            {
                text: '% Comision',
                align: 'center',
                value: 'comision_porc',
            },
            {
                text: 'Acciones',
                value: 'Actions',
                sortable: false,
                align: 'center',
            },
        ],
    }),
    computed: {
        singleObjectives() {
            let singleObjetives = this.objetivoRaw.filter(
                (element) =>
                    element.comercial.id === this.selectedComercial?.id ||
                    element.comercial.id === this.cuenta.id
            );

            // Check if singleObjetives has certain key
            if (singleObjetives.length > 0) {
                if (!singleObjetives[0].hasOwnProperty('objetivo_porc')) {
                    this.definePropertyObjetivos(singleObjetives);
                }
            }

            return singleObjetives;
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        cuenta() {
            return JSON.parse(localStorage.getItem('cuenta'));
        },
        ...mapState('areaPersonal/calculadora', {
            objetivo: (state) => state.objetivo,
            objetivoRaw: (state) => state.objetivoRaw,
            dateActualInmutable: (state) => state.dateActualInmutable,
            currentDate: (state) => state.date,
            objetivoComercial: (state) => state.objetivoComercial,
            selectedComercial: (state) => state.selectedComercial,
            isLoadingFormObjetivo: (state) => state.objetivoForm['isLoading'],
            isLoadingObjetivos: (state) => state.isLoadingObjetivos,
            isOpenDialogObjetivo: (state) => state.objetivoForm.isOpen,
        }),
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
        }),
        ...mapGetters('areaPersonal/calculadora', [
            'definePropertyObjetivos',
            'hasTeamObjectives',
        ]),
    },
    created() {
        if (!this.hasManagerPermission) {
            this.headers.pop();
        } else {
            this.$store.dispatch('areaPersonal/calculadora/fetchTipoObjetivo');
        }
    },
    methods: {
        formatDate,
        formatDateToBD(date) {
            return date.toISOString().split('T')[0];
        },
        openDialogObjetivo() {
            this.$store.commit(
                'areaPersonal/calculadora/isOpenDialogObjetivo',
                true
            );
        },
        isInt(n) {
            return n % 1 === 0;
        },
        itemRowBackground: function (item) {
            let color = '';

            if (item.objetivo == 0) {
                color = 'azul';
            } else if (item.objetivo_porc < 25) {
                color = 'rojo';
            } else if (item.objetivo_porc < 50) {
                color = 'naranja';
            } else if (item.objetivo_porc < 100) {
                color = 'amarillo';
            } else {
                color = 'verde';
            }

            return color;
        },
        calculatePercentageError({ consecucion, five_percent }) {
            return (
                ((consecucion - five_percent) / five_percent) *
                100
            ).toFixed(2);
        },
        itemRowBackgroundFivePercent: function (item) {
            let color = '';

            if (item.objetivo == 0) {
                color = 'azul';
            } else if (this.calculatePercentageError(item) <= -6) {
                color = 'rojo';
            } else if (this.calculatePercentageError(item) <= -1) {
                color = 'naranja';
            } else if (this.calculatePercentageError(item) < 0) {
                color = 'amarillo';
            } else {
                color = 'verde';
            }

            return color;
        },
        deleteObjetivo(item) {
            this.$store.commit('areaPersonal/calculadora/objetivoForm', item);
            this.$store.commit(
                'areaPersonal/calculadora/isLoadingFormObjetivo',
                true
            );
            this.$store.dispatch('areaPersonal/calculadora/deleteObjetivo');
        },
        editObjetivoForm(item) {
            // Find item.id in singleObjectives
            if (this.hasTeamObjectives) {
                item = this.singleObjectives.find(
                    (element) => element.id === item.id
                );
            }

            let form = {
                id: item.id,
                peso: item.peso,
                familia: item.familia,
                objetivo: item.objetivo,
                comercial: item.comercial,
                llave: item.llave,
                fecha: item.fecha,
            };
            this.$store.commit('areaPersonal/calculadora/objetivoForm', form);
            this.$store.commit(
                'areaPersonal/calculadora/isEditingObjetivo',
                true
            );
            this.openDialogObjetivo();
        },
        ...mapActions('areaPersonal/calculadora', ['fetchObjetivo']),
    },
    watch: {
        isOpenDialogObjetivo: {
            immediate: true,
            handler(val) {
                this.singleView = false;
                if (val && !this.objetivo.length) {
                    this.fetchObjetivo({ isForm: true });
                }
            },
        },
    },
};
</script>

<style type="text/css">
.verde {
    background-color: rgb(182, 251, 182);
}

.rojo {
    background-color: rgb(253, 175, 175);
}

.naranja {
    background-color: rgb(255, 217, 147);
}

.amarillo {
    background-color: rgb(254, 252, 140);
}

.azul {
    background-color: #baccff;
}

.v-data-table tr:hover:not(.v-table__expanded__content) {
    background: transparent !important;
}

.prueba {
    background-color: rgb(124, 122, 122);
    border: solid 1px;
}
</style>